import React, {useState, useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import Loader from './Loader';
import Homepage from './homepage'





export default function Route(){
	const [params, setParams] = useState(null);
	const location = useLocation();
	useEffect(() => {
		const queryParams = new URLSearchParams(location.search);
		const singleValue = queryParams.get('media');
		if (!singleValue) return
		setParams(singleValue);
		
	}, []);
	
	return (
	// if you want to add more forms you should do smtg like this: {(params > 1000 && params < 2000) ?  <Form/> : (params > 2000 && params < 3000) ?  <Form2> : <Main/>
    // make sure that <Main/> is in the last option at the end
	// component "Form" is the qatar-charity-ps form
    <>
	
    {/* {(params > 0) ? <Loader albumid={params}/>  :  <Login/>} */}
    {params ? <Loader albumid={params}/>  :  <Homepage/>}
	</>
	)
}